<template>
  <div
    v-if="!hidden"
    class="box-container rounded-12 flex w-fit"
    :class="{ 'border border-amber-900': props.type === 'warning' }"
  >
    <div
      class="clip flex justify-center items-center"
      :class="{
        'bg-amber-500/25': props.type === 'warning',
        'bg-green-500/25': props.type === 'success',
      }"
    >
      <svg role="presentation" focusable="false" tabindex="-1" v-if="props.type === 'warning'"
        class="text-amber-500 icon icon-md mx-3"
         
        alt=""
        svg-inline
       fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
  <path fill="currentColor" d="M16 32a16 16 0 1 0 0-32 16 16 0 0 0 0 32Z"/>
  <path fill="#fff" fill-rule="evenodd" clip-rule="evenodd" d="M16 4.3a2.9 2.9 0 0 1 2.9 3.1l-1.2 10.3c0 .9-.8 1.5-1.6 1.5-1 0-1.6-.6-1.7-1.5L13.2 7.4A2.8 2.8 0 0 1 16 4.3Z"/>
  <path fill="#fff" d="M16 26.7a2.1 2.1 0 1 0 0-4.3 2.1 2.1 0 0 0 0 4.3Z"/>
</svg>
      <span
        v-else-if="props.type === 'success'"
        class="bg-green-800 rounded-full p-1 icon icon-md mx-3"
      >
        <svg role="presentation" focusable="false" tabindex="-1" class="text-white"   alt="" svg-inline  xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32">
<path fill="currentColor" fill-rule="evenodd" d="m11.33 24-5-6.67a1.66 1.66 0 1 1 2.67-2l3.77 5.03 10.3-11.79a1.67 1.67 0 1 1 2.52 2.2L13.92 24.1c-.7.8-1.95.75-2.59-.1" clip-rule="evenodd"/>
</svg>
      </span>
    </div>
    <div class="flex-1 px-3 py-2 lg:py-4" :class="{ 'pr-5': !props.dismissible }">
      <slot />
    </div>
    <button
      v-if="props.dismissible"
      class="flex justify-center items-center px-3"
      @click="hidden = true"
    >
      <svg role="presentation" focusable="false" tabindex="-1" class="icon icon-sm text-gray-400"   alt="close" svg-inline  xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32"><title>close</title>
  <path fill="currentColor" d="M24.63 3.06a3.05 3.05 0 1 1 4.31 4.3L7.37 28.95a3.05 3.05 0 0 1-4.31-4.3L24.63 3.05Z"/>
  <path fill="currentColor" d="M28.94 24.63a3.05 3.05 0 0 1-4.3 4.31L3.05 7.37a3.05 3.05 0 1 1 4.3-4.31l21.58 21.57Z"/>
</svg>
    </button>
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue'

const props = defineProps<{
  type: 'warning' | 'success'
  dismissible?: boolean
}>()

const hidden = ref(false)
</script>

<style scoped>
.clip {
  clip-path: inset(-30% 0 -30% 0 round 0 100% 100% 0);
}
</style>
